// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Jobs subsystem services.
 */

import { AxiosInstance } from 'axios'
import { createJobsApi } from './jobs-api'

export {
  fetchJobStatus,
  type JobStatus,
} from './jobs.service'

export { createJobsApi, type JobContext } from './jobs-api'

// Jobs API singleton - initialized by parent app
let jobsApi: ReturnType<typeof createJobsApi> | null = null

/**
 * Initialize the Jobs API with the provided API instance.
 * Call once during app startup.
 */
export function initializeJobsApi(apiInstance: AxiosInstance) {
  jobsApi = createJobsApi(apiInstance)
  console.log('[Jobs] API initialized')
}

/**
 * Get the initialized jobs API instance.
 * @throws Error if not initialized
 */
export function getJobsApi() {
  if (!jobsApi) {
    throw new Error('Jobs API not initialized. Call initializeJobsApi first.')
  }
  return jobsApi
}
